import axios from 'axios';
import { API_BASE_URL, API_ENDPOINTS } from '@/config/api.config';

/**
 * Les champs natifs du questionnaire et leur reglage « obligatoire ».
 *
 * La liste vient de l'API et d'elle seule: le catalogue y est declare une
 * fois, et c'est lui qui dit quels champs sont reglables, lesquels sont
 * verrouilles et pourquoi. En garder une copie ici ferait deux listes qui
 * divergeraient au premier champ ajoute.
 */
export const surveyFieldService = {
  async getFields() {
    const response = await axios.get(
      `${API_BASE_URL}${API_ENDPOINTS.SURVEY_FIELDS.BASE}`,
    );
    return response.data;
  },

  async setRequired(key, isRequired) {
    const response = await axios.patch(
      `${API_BASE_URL}${API_ENDPOINTS.SURVEY_FIELDS.BY_KEY(key)}`,
      { isRequired },
    );
    return response.data;
  },
};

export default surveyFieldService;
